import { useTranslation } from "react-i18next";
import type { VideoItem } from "@/types";
import { embedUrlWithAutoplay } from "@/lib/video-embed";

/**
 * Renders either the self-hosted <video> or the provider iframe. The iframe src
 * is always the server-normalized `embedUrl`, never the pasted link.
 */
export function VideoPlayer({ video, autoPlay = false }: { video: VideoItem; autoPlay?: boolean }) {
  const { t } = useTranslation();
  return (
    <div className="aspect-video w-full overflow-hidden rounded-2xl bg-black shadow-lg">
      {video.sourceType === "embed" && video.embedUrl ? (
        <iframe
          src={autoPlay ? embedUrlWithAutoplay(video.embedUrl) : video.embedUrl}
          title={video.title}
          className="h-full w-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
          loading="lazy"
        />
      ) : (
        <video
          controls
          playsInline
          autoPlay={autoPlay}
          preload="metadata"
          poster={video.posterUrl ?? undefined}
          src={video.videoUrl}
          className="h-full w-full"
        >
          {t("videoPost.unsupported")}
        </video>
      )}
    </div>
  );
}
